import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioOption',
  props: {
  text: null,
  selected: { type: Boolean, default: false },
  showBtn: { type: Boolean, default: false }
},
  emits: ["btn:click", "radio:click"],
  setup(__props, { emit }) {

const props = __props;





function handleRadio() {
  emit('radio:click')
}

const radioOptionCheck = ref<HTMLInputElement | null>(null)

return { __sfc: true,props, emit, handleRadio, radioOptionCheck }
}

})